<h2 class="popup-heading" mat-dialog-title>Cobra Security Code: {{ show.show_code }}</h2>
<mat-dialog-content class="mat-typography">
    <mat-progress-bar mode="indeterminate" *ngIf="!securityCode"></mat-progress-bar>
    <div class="security-code" *ngIf="securityCode">{{ securityCode }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancel-popup" mat-stroked-button (click) = "close()">Close</button>
</mat-dialog-actions>